import React from "react";
import "./Icons.scss";

const Search = () => {
  return (
    <svg
      className="icon-search"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 27.68 27.46"
    >
      <g>
        <circle className="cls-1" cx="13.82" cy="13.74" r="11.95" />
        <circle className="cls-2" cx="12.19" cy="11.99" r="3.65" />
        <line className="cls-3" x1="14.9" y1="14.65" x2="17.86" y2="17.62" />
      </g>
    </svg>
  );
};

export default Search;
